import { v4 as uuidv4 } from 'uuid';
import List from './actions/list';
import Find from './actions/find';
import Create from './actions/create';
import Resource from './resource';

export default abstract class MediaResource extends Resource {
  optionsForUpload(file, attributes) {
    const options = {
      method: 'POST',
      // @ts-ignore
      path: this.createAction,
      fields: {},
      files: {},
    };

    options.fields[`${this.resourceName}[access_key]`] = attributes.access_key || uuidv4();
    options.files[`${this.resourceName}[file]`] = file;

    return options;
  }

  async create(file, attributes, progress) {
    const options = this.optionsForUpload(file, attributes);
    // @ts-ignore
    options.progress = progress;

    const body = await this.call(options);

    return JSON.parse(body)[this.resourceName];
  }

  async downloadVersion(accessKey, version, callback?) {
    // @ts-ignore
    const body = await this.find(accessKey);
    // @ts-ignore
    return this.download(body[version], callback);
  }

  original(accessKey) {
    this.downloadVersion(accessKey, 'original');
  }
}
// @ts-ignore
List.includeInto(MediaResource);
// @ts-ignore
Find.includeInto(MediaResource);
// @ts-ignore
Create.includeInto(MediaResource);
